import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer'; 
import { Outlet } from 'react-router-dom';


const Layout = ({ children }) => {
    return (
        <div>
            <Header />
            <main className='navFixMargin'>
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
